// removed by extract-text-webpack-plugin
module.exports = {"root":"style__root__znOV0","lastUpdated":"style__lastUpdated__1UTZ6","indentedBullet":"style__indentedBullet__bp9Us"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Taxation/style.css
// module id = 2251
// module chunks = 0